module.exports = __webpack_public_path__ + "static/media/forwardhead_severe_left.d6b8c6d4.png";